import React from 'react'
import Skeleton from 'react-loading-skeleton'

const PostLoaddingComponent = () => {
  return (
    <div className='post-loadding' style={{margin: "10px 0px"}}>
        <div className='loadding-head'>
            <div className='circle'>
                <Skeleton circle style={{width : "50px" , height : "50px"}} />
            </div>
            <div className='line' style={{margin : "0px 8px"}}>
                <Skeleton style={{width : '200px' , height : "10px"}} count={1}></Skeleton>
                <Skeleton style={{width : '100px' , height : "10px"}} count={1}></Skeleton>
            </div>
        </div>
        <div className='loadding-bottom'>
            <Skeleton style={{height : "30px"}} />
        </div>
    </div>
  )
}

export default PostLoaddingComponent
